<template>
  <div class="">
    <el-dialog
      ref="form" v-model="show" :close-on-click-modal="false" title="充值"
      @close="handleCancel">
      <el-form :model="form" label-width="100px">
        <el-form-item prop="name" label="用户" required>
          <span class="user-inline">
            <el-icon :size="16"><User /></el-icon>
            {{ form.username }}
          </span>
        </el-form-item>
        <el-form-item prop="recharge_amount" label="充值金额" :rules="[{required:true,message:' '}]">
          <el-input v-model="form.recharge_amount" placeholder="充值金额" clearable />
        </el-form-item>
        <el-form-item prop="reason" label="备注" :rules="[{required:true,message:' '}]">
          <el-input v-model="form.reason" type="textarea" placeholder="备注" clearable auto-size />
        </el-form-item>
        <el-form-item>
          <el-button style="margin-right:10px;" @click="handleCancel">取 消</el-button>
          <el-button type="primary" @click="handleBeforeOk">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { postPaySecondAgent, postPayClient } from "@/api/douyin-v3/finance";
import { postTiktokFundsAgent } from "@/api/tiktok/funds";
import { postMetaFundsRecharge } from "@/api/meta/funds";
import { postAgentFinancesRecharge } from "@/api/bjh/finances";
import { postFundsAgent } from "@/api/xhs/funds";
import { postFinancesRecharge } from "@/api/tuwen/funds";
import { User } from "@element-plus/icons-vue";


export default {
  components: { User },
  data() {
    return {
      show: false,
      form: {}
    };
  },
  methods: {
    handleOpen(val) {
      this.form = val;
      this.show = true;
    },
    handleCancel() {
      this.show = false;
    },
    handleBeforeOk() {
      if (this.form.level === "dy_agent") {
        postPaySecondAgent(this.form).then(() => {
          this.$message.success("充值成功");
          this.show = false;
          this.$emit("handleOk");
        });
      } else if (this.form.level === "dy_client") {
        postPayClient(this.form).then(() => {
          this.$message.success("充值成功");
          this.show = false;
          this.$emit("handleOk");
        });
      } else if (this.form.level === "xxl_agent") {
        this.form.amount = this.form.recharge_amount;
        postTiktokFundsAgent(this.form).then(() => {
          this.$message.success("充值成功");
          this.show = false;
          this.$emit("handleOk");
        });
      } else if (this.form.level === "meta") {
        this.form.amount = this.form.recharge_amount;
        this.form.user_id = this.form.uid;
        postMetaFundsRecharge(this.form).then(() => {
          this.$message.success("充值成功");
          this.show = false;
          this.$emit("handleOk");
        });
      } else if (this.form.level === "bjh") {
        this.form.amount = this.form.recharge_amount;
        postAgentFinancesRecharge(this.form).then(() => {
          this.$message.success("充值成功");
          this.show = false;
          this.$emit("handleOk");
        });
      } else if (this.form.level === "xhs") {
        this.form.amount = this.form.recharge_amount;
        postFundsAgent(this.form).then(() => {
          this.$message.success("充值成功");
          this.show = false;
          this.$emit("handleOk");
        });
      } else if (this.form.level === "tuwen") {
        this.form.amount = this.form.recharge_amount;
        postFinancesRecharge(this.form).then(() => {
          this.$message.success("充值成功");
          this.show = false;
          this.$emit("handleOk");
        });
      }
    }
  }
};
</script>

<style>

</style>